import Lottie from 'react-lottie';
import * as animationData from '../../img/contact-animation.json';

export default function ContactAnimation() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  return (
    <Lottie options={defaultOptions}
      height={360}
      width={360} />
  );
}